/**
 * @generated SignedSource<<3f51ca78fc05b3943b12ce8587361a0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type getCachedPageDataContentFragment$data = {
  readonly id: string | null;
  readonly status: string | null;
  readonly subType: string | null;
  readonly " $fragmentType": "getCachedPageDataContentFragment";
};
export type getCachedPageDataContentFragment$key = {
  readonly " $data"?: getCachedPageDataContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCachedPageDataContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "getCachedPageDataContentFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ],
  "type": "Content"
};

(node as any).hash = "b940ae3a5484e1099f106d12713d37f5";

export default node;
